export const ARCHIVED_TOOLTIP_MESSAGE = "This to-do has been archived and can no longer be edited.";
export const DOWNLOAD_PERMISSION_MESSAGE = "You don't have permission to download this submission.";
export const READ_ONLY_TOOLTIP_MESSAGE = "You don't have permission to update this to-do.";
